import { render, staticRenderFns } from "./NewChatMessageText.vue?vue&type=template&id=46336a8c"
import script from "./NewChatMessageText.vue?vue&type=script&lang=js"
export * from "./NewChatMessageText.vue?vue&type=script&lang=js"
import style0 from "./NewChatMessageText.vue?vue&type=style&index=0&id=46336a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports